<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>① Nhấn icon [Đăng xuất] ở thanh menu chính của phần trên màn hình, thì thông báo đăng xuất sẽ xuất hiện.</p>
                </div>
                <div><img src="/static\images\vi\newManual\logout_new_1.png" alt="" /></div>
                <div>
                    <p>② Nhấn nút [Ok] tài khoản của bạn sẽ được đăng xuất.</p>
                </div>
                <div><img src="/static\images\vi\newManual\logout_new_2.png" alt="" /></div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <p>① Nhấn icon Menu ở phía dưới màn hình, thì thanh Menu như trên sẽ xuất hiện từ phía bên trái màn hình.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\logout_new_mb_1.png" alt="" /></div>
                <div>
                    <p>② Nhấn icon đăng xuất ở trên cùng sẽ xuất hiện thông báo đăng xuất</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\logout_new_mb_2.png" alt="" /></div>
                <div>
                    <p>③  Nhấn nút [Ok] tài khoản của bạn sẽ được đăng xuất.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\logout_new_mb_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/logout_manual.vue